import api from './api';

const exportRunService = {
  async list(params = {}) {
    const response = await api.get('/export-runs', { params });
    return response.data;
  },

  async get(id) {
    const response = await api.get(`/export-runs/${id}`);
    return response.data;
  },

  async download(id) {
    const response = await api.get(`/export-runs/${id}/download`);
    return response.data;
  },

  async prepareAdjustmentGuideDocument(guideId) {
    const response = await api.post(`/entry-guides/${guideId}/prepare-document-data`);
    return response.data;
  },
};

export default exportRunService;
